import React from 'react';
import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import JobsTab from './components/JobsTab';
import ReferralsTab from './components/ReferralsTab';
import RewardsTab from './components/RewardsTab';
import User from '../../../api/user';

export default function JobReferrals() {
  const userInfo = User.GetInfo();
  const isSuperAdmin = userInfo?.type === 1;

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <Tabs align="start" variant="enclosed" isLazy lazyBehavior="keepMounted">
        <TabList>
          <Tab>משרות</Tab>
          <Tab>הפניות</Tab>
          <Tab>תגמולים</Tab>
        </TabList>
        <TabPanels>
          <TabPanel px={0}>
            <JobsTab isSuperAdmin={isSuperAdmin} />
          </TabPanel>
          <TabPanel px={0}>
            <ReferralsTab isSuperAdmin={isSuperAdmin} />
          </TabPanel>
          <TabPanel px={0}>
            <RewardsTab isSuperAdmin={isSuperAdmin} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
}
